import React from 'react';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheckCircle,
  faExclamationTriangle,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';

const showToast = (type, message) => {
  const icons = {
    success: <FontAwesomeIcon icon={faCheckCircle} />,
    warning: <FontAwesomeIcon icon={faExclamationTriangle} />,
    error: <FontAwesomeIcon icon={faTimesCircle} />,
  };

  toast[type](message, {
    icon: icons[type] || null,
  });
};

export default showToast;
